import {useState} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './dragAndDropArea.scss';


export default function DragAndDropArea({
                                         className = '',
                                         disabled = false,
                                         onDropHandler = null,
                                         children = null,
                                       }) {


  const [isDragOver, setIsDragOver] = useState(false);


  // Fires once when the drag enters the zone. Mounting the overlay here means all further
  // dragover/dragleave events land on the overlay (which covers the zone fully)
  const onZoneDragEnterHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    e.dataTransfer.dropEffect = disabled ? 'none' : 'copy';

    setIsDragOver(true);
  }

  // Required so the browser allows dropping on this element before the overlay has mounted.
  const onZoneDragOverHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    e.dataTransfer.dropEffect = disabled ? 'none' : 'copy';

  }

  const onOverlayDragOverHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    e.dataTransfer.dropEffect = disabled ? 'none' : 'copy';
  }

  const onOverlayDragLeaveHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragOver(false);
  }

  const onOverlayDropHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragOver(false);
    if (!disabled) {
      onDropHandler?.(e);
    }
  }

  return (
    <div className={cn('drag-drop-area', className,  {disabled: disabled})}
         onDragEnter={onZoneDragEnterHandler}
         onDragOver={onZoneDragOverHandler}
    >

      {children}

      {isDragOver &&
        <div className={cn('drag-drop-area-overlay', {disabled: disabled})}
             onDragOver={onOverlayDragOverHandler}
             onDragLeave={onOverlayDragLeaveHandler}
             onDrop={onOverlayDropHandler}>
        </div>
      }
    </div>
  )
}

DragAndDropArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onDropHandler: PropTypes.func,
  children: PropTypes.any,
}
